export default class AnchorLinks {

    static initializeEvents() {
        Array.from(document.querySelectorAll('a[href^="#"]')).forEach(link => {
            link.addEventListener('click', event => {
                /** @type {HTMLLinkElement} */
                const element = event.target;

                setTimeout(() => {
                    if (document.activeElement.tagName === 'BODY') {
                        element.focus({preventScroll: true});
                    }
                }, 100);
            });
        });

        setTimeout(() => {
            this.adjustScrollForAnchor();
        }, 100);
        window.adjustScrollForAnchor = this.adjustScrollForAnchor;
    }

    static adjustScrollForAnchor(url = new URL(window.location.href), event) {
        const anchor = url.hash;
        const anchorWithoutHash = decodeURIComponent(anchor.substring(1));
        if (anchorWithoutHash) {
            const anchorLink = document.getElementById(anchorWithoutHash);

            if (anchorLink) {
                const totalHeight = AnchorLinks.calculateTotalHeight('.header-mobile, #menu-main');
                const offsetPosition = anchorLink.getBoundingClientRect().top + window.scrollY - totalHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
                if (event) event.preventDefault();
                history.pushState(null, '', url);
            } else {
                console.warn('L\'ancre spécifiée n\'existe pas dans le document.');
            }
        }
    }

    static calculateTotalHeight(selectors = '.header-mobile, #menu-main, .header') {
        let totalHeight = 0;
        document.querySelectorAll(selectors).forEach(element => {
            totalHeight += element.offsetHeight;
        });

        return totalHeight;
    }

}